import {createReducer, createSlice} from "@reduxjs/toolkit";
import {createAction} from 'redux-actions';
import _ from 'lodash'

export const setActiveTab = createAction("SET_ACTIVE_TAB");
export const setSelectedHotspotId = createAction("SET_SELECTED_HOT_SPOT_ID");
export const updateHotspot = createAction("UPDATE_HOT_SPOT");
export const clearHotspot = createAction("CLEAR_HOT_SPOT");
export const applyHotspotChanges = createAction("APPLY_HOT_SPOT_CHANGES");
export const applyAccountOrganizationChanges = createAction("APPLY_ACCOUNT_ORGANIZATION_CHANGES");
export const setSelectedSupportChatSessionId = createAction("SET_SELECTED_SUPPORT_CHAT_SESSION_ID");

export const appendSupportChatSession = createAction("APPEND_SUPPORT_CHAT_SESSION")
export const appendSupportChatMessage = createAction("APPEND_SUPPORT_CHAT_MESSAGE")
export const appendSupportChatMessages = createAction("APPEND_SUPPORT_CHAT_MESSAGES")
export const setSupportChatSessionId = createAction("SET_SUPPORT_CHAT_SESSION_ID")

export const updateAccountData = createAction("UPDATE_ACCOUNT_DATA");
export const updateSupportChatSession = createAction("UPDATE_SUPPORT_CHAT_SESSION");
export const appendAccountSupportChatMessage = createAction("APPEND_ACCOUNT_SUPPORT_CHAT_MESSAGE")
export const appendAccountSupportChatMessages = createAction("APPEND_ACCOUNT_SUPPORT_CHAT_MESSAGES")

export const setAblyConnectionToken = createAction("SET_ABLY_CONNECTION_TOKEN")

const reducer = createReducer({}, {
  [setAblyConnectionToken]: (state, action) => {
    state.connectionToken = action.payload
  },
  [setSelectedHotspotId]: (state, action) => {
    if(state.selectedHotspotId != action.payload)
      state.selectedHotspotId = action.payload;
  },
  [updateHotspot]: (state, action) => {
    state.hotspotUpdateData[action.payload.id] = action.payload
  },
  [clearHotspot]: (state, action) => {
    state.hotspotUpdateData = {}
    state.selectedHotspotId = null
    console.log("clreaing hotspot", state.selectedHotspotId)
  },
  [applyHotspotChanges]: (state, action) => {
    const updatedHotspots = Object.values(state.hotspotUpdateData)

    // Filter update hotspots from image map
    state.imageHotspots = state.imageHotspots.filter(hotspot => updatedHotspots.some(updatedHotspot => hotspot.id !== updatedHotspot.id))

    // Add the updated hotspot data
    state.imageHotspots = state.imageHotspots.concat(updatedHotspots)

    state.hotspotUpdateData = {}
  },
  [applyAccountOrganizationChanges]: (state, action) => {
    state.accountOrganization = action.payload
  },
  [setSelectedSupportChatSessionId]: (state, action) => {
    state.selectedSupportChatSessionId = action.payload
  },
  [updateSupportChatSession]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((supportChatSession) => supportChatSession.id !== action.payload.id)
    state.supportChatSessions.push(action.payload)
  },
  [appendAccountSupportChatMessage]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter(scm => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  [appendAccountSupportChatMessages]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter(scm => action.payload.every(m => m.id !== scm.id))
    state.supportChatMessages = state.supportChatMessages.concat(action.payload)
  },
  [updateAccountData]: (state, action) => {
    state.account = action.payload
  },

  ["CABLE_ACCOUNT_ORGANIZATION_UPDATED"]: (state, action) => {
    if (state.accountOrganization.id === action.payload.id) {
      state.account_organization = action.payload
    }
  },

  ["CABLE_SUPPORT_CHAT_SESSION_CREATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_UPDATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_DESTROYED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_MESSAGE_CREATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
  },

  ["CABLE_MEDIA_FILE_CREATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_UPDATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_DESTROYED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_CREATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_CREATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_CREATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_UPDATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_DESTROYED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
  }
});

export default reducer;
